// extracted by mini-css-extract-plugin
module.exports = {"docLink":"_3Ds08O1_SXS1PzQZeq4DL1","uploadButton":"_35r57aIMi0_ilK6RAIn0su"};